<smart-card class="smart-card" style="margin: 0 auto; display: flex; align-items: center">
  <h1 [innerText]="title | translate"></h1>
  <p [innerText]="description | translate"></p>

  <div class="container matero-row d-flex flex-row flex-wrap">
    <div class="w-full d-flex flex-row flex-wrap justify-center items-start">
      @for (item of items | async; track item) {
        @if (item.visibleOnDashboard !== false) {
          <div class="dashboard-tile">
            <a [routerLink]="'../' + item.route" [queryParams]="item.queryParams">
              <mat-card
                appearance="outlined"
                class="mat-elevation-z5 dashboard-card"
                style="border-radius: 4px !important"
              >
                <h1 [style.color]="'var(--theme-primary-700)'">
                  <mat-icon>{{ item.icon }}</mat-icon>
                </h1>
                <h3 [style.color]="'var(--theme-accent-700)'">{{ item.name | translate }}</h3>
              </mat-card>
            </a>
          </div>
        }
      }
    </div>
  </div>
</smart-card>
